import { vuexOidcCreateStoreModule, vuexOidcUserManager } from '@/config/vuex-oidc.esm';

import oidcSettings from '@/config/oidc';

export default {
  actions: {},
  modules: {
    oidc: vuexOidcCreateStoreModule(oidcSettings, { namespaced: true },
      {
        userLoaded: (user) => {
          let type = '';
          if (user['profile.UserType']) {
            if (Array.isArray(user['profile.UserType'])) {
              type = user['profile.UserType'][0].toLowerCase();
            } else {
              type = user['profile.UserType'].toLowerCase();
            }
          } else {
            type = 'internal';
          }
          vuexOidcUserManager()._settings.extraQueryParams = { userType: type };
        },
      }),
  },
};
